import countries from "@/assets/js/countries";
import store from "../controller/baseController";
import Enums from "../enums/enums";
import peakUtility from "../function/peakUtility";
import userInfo from "../function/userInfo";
import i18n from "../locales/i18n";
import shareHelper from "./shareHelper";
import textHelper from "./textHelper";

export const PrepareFavoriteContact = (input) => {
  let favoriteTypeId = Enums.FavoriteType.None;
  switch (input.transactionTypeId) {
    case Enums.TransactionType.PurchaseRequisition:
      favoriteTypeId = Enums.FavoriteType.PurchaseRequisition;
      break;
    case Enums.TransactionType.Quotation:
      favoriteTypeId =
        input.financeTypeId === Enums.FinanceType.InFlow
          ? Enums.FavoriteType.Quotation
          : Enums.FavoriteType.PurchaseOrder;
      break;
    case Enums.TransactionType.Deposit:
      favoriteTypeId =
        input.financeTypeId === Enums.FinanceType.InFlow
          ? Enums.FavoriteType.Deposit
          : Enums.FavoriteType.ReceiveDeposit;
      break;
    case Enums.TransactionType.GoodsReceipt:
      favoriteTypeId = Enums.FavoriteType.GoodsReceipt;
      break;
    case Enums.TransactionType.InvoiceReceipt:
      favoriteTypeId = Enums.FavoriteType.InvoiceReceipt;
      break;
    case Enums.TransactionType.Invoice:
      if (input.expenseTypeId === Enums.ExpenseType.None) {
        favoriteTypeId = Enums.FavoriteType.Invoice;
      } else if (input.expenseTypeId === Enums.ExpenseType.Expense) {
        favoriteTypeId = Enums.FavoriteType.ExpenseRecord;
      } else if (input.expenseTypeId === Enums.ExpenseType.PurchaseInventory) {
        favoriteTypeId = Enums.FavoriteType.PurchaseInventoryRecord;
      } else {
        favoriteTypeId = Enums.FavoriteType.PurchaseAsset;
      }
      break;
    case Enums.TransactionType.Receipt:
      favoriteTypeId = Enums.FavoriteType.Receipt;
      break;
    case Enums.TransactionType.TaxInvoice:
      favoriteTypeId =
        input.financeTypeId === Enums.FinanceType.InFlow
          ? Enums.FavoriteType.TaxInvoice
          : Enums.FavoriteType.PurchaseTaxInvoice;
      break;
    case Enums.TransactionType.CreditNote:
      favoriteTypeId =
        input.financeTypeId === Enums.FinanceType.InFlow
          ? Enums.FavoriteType.CreditNote
          : Enums.FavoriteType.ReceiveCreditNote;
      break;
    case Enums.TransactionType.DebitNote:
      favoriteTypeId =
        input.financeTypeId === Enums.FinanceType.InFlow
          ? Enums.FavoriteType.DebitNote
          : Enums.FavoriteType.ReceiveDebitNote;
      break;
    case Enums.TransactionType.BillingNote:
      favoriteTypeId =
        input.financeTypeId === Enums.FinanceType.InFlow
          ? Enums.FavoriteType.BillingNote
          : Enums.FavoriteType.CombinedPaymentNote;
      break;
  }
  let favoriteContactInput = {
    contactId: input.contactId,
    favoriteTypeId: favoriteTypeId,
  };
  return favoriteContactInput;
};

export default {
  SetContactCreateTemplate() {
    return SetContactCreateTemplate();
  },
  InputInsertContactTemplateBasic(_contact, contactTemplateDefault) {
    let contactTemplate = contactTemplateDefault;
    contactTemplate.id = _contact.id;
    contactTemplate.contactFinanceType = _contact.contactFinanceType;
    contactTemplate.taxId = _contact.taxId;
    contactTemplate.branchCode = _contact.branchCode;
    contactTemplate.branchTypeId = _contact.branchTypeId;
    contactTemplate.contactContryId = _contact.contactContryId;
    contactTemplate.typeCompany = _contact.typeCompany;
    contactTemplate.typeOfPerson = _contact.typeOfPerson;
    contactTemplate.companyName = _contact.companyName;
    contactTemplate.firstname = _contact.firstname;
    contactTemplate.lastname = _contact.lastname;
    contactTemplate.prefixName = _contact.prefixName;
    contactTemplate.prefixOtherName = _contact.prefixOtherName;
    contactTemplate.registeredAddress.address = _contact.registeredAddress.address;
    contactTemplate.registeredAddress.district = _contact.registeredAddress.district;
    contactTemplate.registeredAddress.amphoe = _contact.registeredAddress.amphoe;
    contactTemplate.registeredAddress.province = _contact.registeredAddress.province;
    contactTemplate.registeredAddress.contactName = _contact.registeredAddress.contactName;
    contactTemplate.registeredAddress.zipcode = _contact.registeredAddress.zipcode;
    contactTemplate.registeredAddress.country = _contact.registeredAddress.country;
    contactTemplate.registeredAddress.building = _contact.registeredAddress.building;
    contactTemplate.registeredAddress.road = _contact.registeredAddress.road;
    contactTemplate.registeredAddress.state = _contact.registeredAddress.state;
    contactTemplate.registeredAddress.city = _contact.registeredAddress.city;
    contactTemplate.email = _contact.email;
    contactTemplate.phoneNumber = _contact.phoneNumber;
    contactTemplate.faxNumber = _contact.faxNumber;
    contactTemplate.website = _contact.website;
    contactTemplate.contactCode = _contact.contactCode;
    contactTemplate.contactGroup = _contact.contactGroup;
    contactTemplate.creditLimitSettingType = _contact.creditLimitSettingType;
    contactTemplate.accountRecordSetting.selectInvoiceReceiptGoodsReceipt =
      _contact.accountRecordSetting.selectInvoiceReceiptGoodsReceipt;
    return contactTemplate;
  },
  InputInsertContactTemplate(_contact) {
    let contact = {
      id: _contact.id,
      contactFinanceType: _contact.contactFinanceType.value,
      name: peakUtility.RemoveFirstSpecialCharacterThai(
        _contact.typeOfPerson.value == Enums.TypeOfPerson.OrdinaryPerson &&
          _contact.typeCompany.value == Enums.MerchantType.OrdinaryPerson
          ? _contact.firstname.value.trim() + " " + _contact.lastname.value.trim()
          : _contact.companyName.value.trim()
      ),
      isVat: 0,
      email: _contact.email.value,
      phone: _contact.phoneNumber.value,
      address: {
        address: peakUtility.RemoveFirstSpecialCharacterThai(_contact.shippingAddress.address.value),
        subDistrict: peakUtility.RemoveFirstSpecialCharacterThai(
          _contact.contactContryId == 1 ? _contact.shippingAddress.district.value : ""
        ),
        district: peakUtility.RemoveFirstSpecialCharacterThai(
          _contact.contactContryId == 1 ? _contact.shippingAddress.amphoe.value : _contact.shippingAddress.city.value
        ),
        province: peakUtility.RemoveFirstSpecialCharacterThai(
          _contact.contactContryId == 1 ? _contact.shippingAddress.province.value : _contact.shippingAddress.state.value
        ),
        country: peakUtility.RemoveFirstSpecialCharacterThai(
          _contact.shippingAddress.country ? _contact.shippingAddress.country.name : "Thailand"
        ),
        road: peakUtility.RemoveFirstSpecialCharacterThai(
          _contact.contactContryId == 1 ? null : _contact.shippingAddress.road.value
        ),
        building: peakUtility.RemoveFirstSpecialCharacterThai(
          _contact.contactContryId == 1 ? null : _contact.shippingAddress.building.value
        ),
        postCode: peakUtility.RemoveFirstSpecialCharacterThai(_contact.shippingAddress.zipcode.value),
      },
      merchantType: _contact.typeCompany.value,
      contactName: peakUtility.RemoveFirstSpecialCharacterThai(_contact.shippingAddress.contactName.value),
      fax: _contact.faxNumber.value,
      website: _contact.website.value,
      code: _contact.contactCode.value,
      invoiceIncomeType: _contact.setDueDate.dueToInvoicePayment.value,
      invoiceIncomeValue: _contact.setDueDate.dayForInvoicePayment.value,
      accountsReceivableAccountId: _contact.accountRecordSetting.selectReceivableRecorded.id,
      invoiceExpenseType: _contact.setDueDate.dueToExpenses.value,
      invoiceExpenseValue: _contact.setDueDate.dayForExpenses.value,
      accountsPayableAccountId: _contact.accountRecordSetting.selectPayableRecorded.id,
      personalNamePrefixType: _contact.prefixName.value,
      personalNamePrefixOther:
        _contact.prefixName.value == Enums.PrefixNameType.Other ? _contact.prefixOtherName.value : null,
      taxId: _contact.taxId.value,
      bankInformation: BankInformation(_contact.bankInformation),
      personToContact: PersonToContact(_contact.personToContact),
      contactGroupIdList: ToContactGroupIdList(_contact.contactGroup),
      fax: _contact.faxNumber.value,
      website: _contact.website.value,
      contactBranchModel: {
        id: _contact.contactBranchId,
        name: peakUtility.RemoveFirstSpecialCharacterThai(_contact.registeredAddress.contactName.value),
        branchCode: _contact.branchTypeId == 1 ? "00000" : _contact.branchCode.value,
        address: {
          address: peakUtility.RemoveFirstSpecialCharacterThai(_contact.registeredAddress.address.value),
          subDistrict: peakUtility.RemoveFirstSpecialCharacterThai(
            _contact.contactContryId == 1 ? _contact.registeredAddress.district.value : ""
          ),
          district:
            _contact.contactContryId == 1
              ? peakUtility.RemoveFirstSpecialCharacterThai(_contact.registeredAddress.amphoe.value)
              : peakUtility.RemoveFirstSpecialCharacterThai(_contact.registeredAddress.city.value),
          province:
            _contact.contactContryId == 1
              ? peakUtility.RemoveFirstSpecialCharacterThai(_contact.registeredAddress.province.value)
              : peakUtility.RemoveFirstSpecialCharacterThai(_contact.registeredAddress.state.value),
          country: peakUtility.RemoveFirstSpecialCharacterThai(
            _contact.registeredAddress.country || _contact.contactContryId == 2
              ? _contact.registeredAddress.country.name
              : "Thailand"
          ),
          road: peakUtility.RemoveFirstSpecialCharacterThai(
            _contact.contactContryId == 1 ? null : _contact.registeredAddress.road.value
          ),
          building: peakUtility.RemoveFirstSpecialCharacterThai(
            _contact.contactContryId == 1 ? null : _contact.registeredAddress.building.value
          ),
          postcode: peakUtility.RemoveFirstSpecialCharacterThai(_contact.registeredAddress.zipcode.value),
        },
      },
      contactCreditLimit:
        _contact.creditLimitSettingType === Enums.CreditLimitType.Custom ? _contact.contactCreditLimit.value : 0,
      creditLimitSettingType: _contact.creditLimitSettingType,
      invoiceReceiptGoodsReceiptAccountId: _contact.accountRecordSetting.selectInvoiceReceiptGoodsReceipt.id,
    };
    return contact;
  },
  ValidateInsertContact(contact) {
    if (
      contact.typeOfPerson.value == Enums.TypeOfPerson.OrdinaryPerson &&
      contact.typeCompany.value == Enums.MerchantType.OrdinaryPerson
    ) {
      if (
        peakUtility.RemoveFirstSpecialCharacterThai(contact.firstname.value) == "" ||
        peakUtility.RemoveFirstSpecialCharacterThai(contact.firstname.value).length > 40
      ) {
        contact.firstname.validateError = true;
      } else {
        contact.firstname.validateError = false;
      }
      if (peakUtility.RemoveFirstSpecialCharacterThai(contact.lastname.value).length > 40) {
        contact.lastname.validateError = true;
      } else {
        contact.lastname.validateError = false;
      }
      if (contact.prefixName.value == Enums.PrefixNameType.Other) {
        if (
          peakUtility.RemoveFirstSpecialCharacterThai(contact.prefixOtherName.value == "") ||
          (peakUtility.RemoveFirstSpecialCharacterThai(contact.prefixOtherName.value) &&
            peakUtility.RemoveFirstSpecialCharacterThai(contact.prefixOtherName.value).length > 32)
        ) {
          contact.prefixOtherName.validateError = true;
        } else {
          contact.prefixOtherName.validateError = false;
        }
      }
      contact.companyName.validateError = false;
    } else {
      if (
        peakUtility.RemoveFirstSpecialCharacterThai(contact.companyName.value) == "" ||
        (peakUtility.RemoveFirstSpecialCharacterThai(contact.companyName.value) &&
          peakUtility.RemoveFirstSpecialCharacterThai(contact.companyName.value).length > 100)
      ) {
        contact.companyName.validateError = true;
      } else {
        contact.companyName.validateError = false;
      }
      contact.firstname.validateError = false;
      contact.lastname.validateError = false;
      contact.prefixOtherName.validateError = false;
    }

    if (contact.contactCode.value == "") {
      contact.contactCode.validateError = true;
    }
    if (contact.setDueDate.dayForExpenses.value > 366) {
      contact.setDueDate.dayForExpenses.validateError = true;
    }
    if (contact.setDueDate.dayForInvoicePayment.value > 366) {
      contact.setDueDate.dayForInvoicePayment.validateError = true;
    }
    if (
      ValidateContactCodeError(contact) &&
      ValidateContactBusinessNameInformationError(contact) &&
      ValidateContactRegisteredAddressError(contact) &&
      ValidateContactShippingAddressError(contact) &&
      ValidateContactInfoError(contact) &&
      ValidateContactPersonError(contact) &&
      ValidateContactBankAccountError(contact) &&
      ValidateContactSetDueDateError(contact) &&
      ValidateContactCreditLimitError(contact)
    ) {
      return true;
    } else {
      return false;
    }
  },
  ExceptionInsertContactTemplate(res, contact) {
    switch (res.exception.code) {
      case Enums.PeakExceptionResponseCode.ContactCodeIsDuplicated:
        contact.contactCode.validateError = true;
        return i18n.t("Duplicate_Contact_Code_Please_Enter_New_Contact_Code");
        break;
      case Enums.PeakExceptionResponseCode.ContactNameIsDuplicated:
        if (
          contact.typeOfPerson.value == Enums.TypeOfPerson.OrdinaryPerson &&
          contact.typeCompany.value == Enums.MerchantType.OrdinaryPerson
        ) {
          contact.firstname.validateError = true;
          contact.lastname.validateError = true;
        } else {
          contact.companyName.validateError = true;
        }
        return i18n.t("Create_contact_failed_because_contact_name_is_duplicated");
        break;
      case Enums.PeakExceptionResponseCode.MerchantIsNotAllowDuplicateContactTaxId:
      case Enums.PeakExceptionResponseCode.TaxIdIsDuplicated:
        return i18n.t("Tax_Registration_Number_Is_Already_Added_Your_Contact");
        break;
      case Enums.PeakExceptionResponseCode.MerchantIsNotAllowDuplicateContact:
        if (
          contact.typeOfPerson.value == Enums.TypeOfPerson.OrdinaryPerson &&
          contact.typeCompany.value == Enums.MerchantType.OrdinaryPerson
        ) {
          contact.firstname.validateError = true;
          contact.lastname.validateError = true;
        } else {
          contact.companyName.validateError = true;
        }
        return i18n.t("Create_contact_failed_because_contact_name_is_duplicated");
        break;
      default:
        return i18n.t("Something_Wrong") + res.exception.errorCode ? " Error Code:" + res.exception.errorCode : "";
        break;
      case Enums.PeakExceptionResponseCode.ContactPersonNamePrefixOtherMaxLength:
      case Enums.PeakExceptionResponseCode.ContactNamePrefixOtherMaxLength:
        return i18n.t("Contact_Prefix_Incorrect_Format");
    }
  },
  ExceptionCheckDuplicate(res, contact) {
    let contactDuplicate = {
      contactName: "",
      contactNameIsDuplicated: false,
    };
    switch (res.exception.code) {
      case Enums.PeakExceptionResponseCode.ContactNameIsDuplicated:
        contactDuplicate.contactName =
          contact.typeOfPerson.value == Enums.TypeOfPerson.OrdinaryPerson &&
          contact.typeCompany.value == Enums.MerchantType.OrdinaryPerson
            ? contact.firstname.value + " " + contact.lastname.value
            : contact.companyName.value;
        contactDuplicate.contactNameIsDuplicated = true;
        break;
      case Enums.PeakExceptionResponseCode.TaxIdIsDuplicated:
        contactDuplicate.contactName = contact.taxId;
        contactDuplicate.contactNameIsDuplicated = true;
        break;
      case Enums.PeakExceptionResponseCode.MerchantIsNotAllowDuplicateContact:
        contactDuplicate.contactName =
          contact.typeOfPerson.value == Enums.TypeOfPerson.OrdinaryPerson &&
          contact.typeCompany.value == Enums.MerchantType.OrdinaryPerson
            ? contact.firstname.value + " " + contact.lastname.value
            : contact.companyName.value;
        contactDuplicate.contactNameIsDuplicated = true;
        break;
    }
    return contactDuplicate;
  },
  SetContactCreateTemplateBySearchedContactAddress(contactCreateTemplate, searchedAddress) {
    contactCreateTemplate.taxId.value = searchedAddress.taxId;
    if (searchedAddress.branchCode === "") {
      contactCreateTemplate.branchTypeId = Enums.BranchCompanyType.None;
    } else if (searchedAddress.branchCode === "00000") {
      contactCreateTemplate.branchTypeId = Enums.BranchCompanyType.Quarter;
    } else {
      contactCreateTemplate.branchTypeId = Enums.BranchCompanyType.Branch;
    }
    contactCreateTemplate.branchCode.value = searchedAddress.branchCode;
    contactCreateTemplate.logoUrl = searchedAddress.logoUrl;
    contactCreateTemplate.typeOfPerson = shareHelper.GetTypeOfPersonBySearchedAddress(searchedAddress.merchantType);
    contactCreateTemplate.typeCompany = { value: searchedAddress.merchantType };
    if (
      contactCreateTemplate.typeOfPerson.value === Enums.TypeOfPerson.OrdinaryPerson &&
      searchedAddress.merchantType === Enums.MerchantType.OrdinaryPerson
    ) {
      searchedAddress.name = searchedAddress.name.trim();
      let fullName = searchedAddress.name.split(/ (.*)/);
      contactCreateTemplate.firstname.value = fullName.length > 0 ? fullName[0] : "";
      contactCreateTemplate.lastname.value = fullName.length > 1 ? fullName[1] : "";
      contactCreateTemplate.prefixName = { value: searchedAddress.personalNamePrefixTypeId };
    } else {
      contactCreateTemplate.companyName.value = searchedAddress.name;
    }
    contactCreateTemplate.verificationStatus = searchedAddress.verificationStatus;
    contactCreateTemplate.registeredAddress.address.value = `${
      searchedAddress.no ? "เลขที่ " + searchedAddress.no : ""
    } ${searchedAddress.homeNo ? "หมู่ " + searchedAddress.homeNo : ""} ${
      searchedAddress.roomNo ? "ห้อง " + searchedAddress.roomNo : ""
    } ${searchedAddress.floorNo ? "ชั้น " + searchedAddress.floorNo : ""} ${
      searchedAddress.building ? "อาคาร " + searchedAddress.building : ""
    } ${searchedAddress.soi ? "ซอย " + searchedAddress.soi : ""} ${
      searchedAddress.road ? "ถนน " + searchedAddress.road : ""
    }`;
    contactCreateTemplate.registeredAddress.district.value = searchedAddress.subDistrict;
    contactCreateTemplate.registeredAddress.amphoe.value = searchedAddress.district;
    contactCreateTemplate.registeredAddress.province.value = searchedAddress.province;
    contactCreateTemplate.registeredAddress.zipcode.value = searchedAddress.postCode;
    contactCreateTemplate.email.value = searchedAddress.email ? searchedAddress.email : "";
    contactCreateTemplate.phoneNumber.value = searchedAddress.phone ? searchedAddress.phone : "";
    contactCreateTemplate.website.value = searchedAddress.website ? searchedAddress.website : "";
    contactCreateTemplate.faxNumber.value = searchedAddress.fax ? searchedAddress.fax : "";
  },
  SetContactTemplateForEdit(contactTemplate, contactDetail) {
    contactTemplate.modalCreateType = 2;
    contactTemplate.id = contactDetail.id;
    contactTemplate.contactBranchId = contactDetail.contactBranchModel.id;
    contactTemplate.taxId = { value: contactDetail.taxId };
    contactTemplate.branchCode = { value: contactDetail.contactBranchModel.branchCode };
    contactTemplate.contactFinanceType = { value: contactDetail.contactFinanceType };
    contactTemplate.branchTypeId = contactTemplate.branchCode.value
      ? contactTemplate.branchCode.value === "00000"
        ? 1
        : 2
      : 0;

    contactTemplate.contactContryId =
      (contactTemplate.taxId.value == "" || contactTemplate.taxId.value.length == 13) &&
      contactDetail.contactBranchModel.address.country == "Thailand"
        ? 1
        : 2;

    contactTemplate.contactCode = { value: contactDetail.code };
    contactTemplate.typeCompany = { value: contactDetail.merchantType };
    contactTemplate.typeOfPerson = shareHelper.GetTypeOfPersonBySearchedAddress(contactDetail.merchantType);
    if (
      contactTemplate.typeOfPerson.value === Enums.TypeOfPerson.OrdinaryPerson &&
      contactDetail.merchantType === Enums.MerchantType.OrdinaryPerson
    ) {
      let fullName = contactDetail.name.split(/ (.*)/);
      contactTemplate.firstname.value = fullName.length > 0 ? fullName[0] : "";
      contactTemplate.lastname.value = fullName.length > 1 ? fullName[1] : "";
      contactTemplate.prefixName = { value: contactDetail.personalNamePrefixType };
      if (contactTemplate.prefixName.value == Enums.PrefixNameType.Other) {
        contactTemplate.prefixOtherName = { value: contactDetail.personalNamePrefixOther };
      }
    } else {
      contactTemplate.companyName.value = contactDetail.name;
    }
    contactTemplate.registeredAddress.contactName.value = contactDetail.contactBranchModel.address.contactName;
    contactTemplate.registeredAddress.address.value = contactDetail.contactBranchModel.address.address;
    contactTemplate.registeredAddress.district.value = contactDetail.contactBranchModel.address.subDistrict;
    contactTemplate.registeredAddress.amphoe.value = contactDetail.contactBranchModel.address.district;
    contactTemplate.registeredAddress.province.value = contactDetail.contactBranchModel.address.province;
    contactTemplate.registeredAddress.zipcode.value = contactDetail.contactBranchModel.address.postCode;
    contactTemplate.registeredAddress.road.value = contactDetail.contactBranchModel.address.road;
    contactTemplate.registeredAddress.building.value = contactDetail.contactBranchModel.address.building;
    contactTemplate.registeredAddress.city.value = contactDetail.contactBranchModel.address.district;
    contactTemplate.registeredAddress.state.value = contactDetail.contactBranchModel.address.province;

    contactTemplate.shippingAddress.contactName.value = contactDetail.address.contactName;
    contactTemplate.shippingAddress.address.value = contactDetail.address.address;
    contactTemplate.shippingAddress.district.value = contactDetail.address.subDistrict;
    contactTemplate.shippingAddress.amphoe.value = contactDetail.address.district;
    contactTemplate.shippingAddress.province.value = contactDetail.address.province;
    contactTemplate.shippingAddress.zipcode.value = contactDetail.address.postCode;
    contactTemplate.shippingAddress.road.value = contactDetail.address.road;
    contactTemplate.shippingAddress.building.value = contactDetail.address.building;
    contactTemplate.shippingAddress.city.value = contactDetail.address.district;
    contactTemplate.shippingAddress.state.value = contactDetail.address.province;

    let countryList = [];
    countries.forEach((countrie) => {
      let countrieObject = {
        name: countrie.enName,
        code: countrie.alpha2,
      };
      countryList.push(countrieObject);
    });
    contactTemplate.registeredAddress.country = countryList.find(
      (x) => x.name == contactDetail.contactBranchModel.address.country
    );
    contactTemplate.shippingAddress.country = countryList.find((x) => x.name == contactDetail.address.country);

    contactTemplate.email.value = contactDetail.email;
    contactTemplate.phoneNumber.value = contactDetail.phone;
    contactTemplate.website.value = contactDetail.website;
    contactTemplate.faxNumber.value = contactDetail.fax;
    contactTemplate.contactCreditLimit.value = contactDetail.contactCreditLimit.FormatMoney();
    contactTemplate.creditLimitSettingType = contactDetail.creditLimitSettingType;

    if (contactDetail.personToContact && contactDetail.personToContact.length > 0) {
      contactTemplate.personToContact = SetPersonToContactDetail(contactDetail.personToContact);
    }

    if (contactDetail.bankInformation && contactDetail.bankInformation.length > 0) {
      contactTemplate.bankInformation = SetBankInformation(contactDetail.bankInformation);
    }

    if (contactDetail.groupList && contactDetail.groupList.length > 0) {
      contactTemplate.contactGroup = SetContactGroup(contactDetail.groupList);
    }

    contactTemplate.setDueDate.dayForExpenses.value = contactDetail.invoiceExpenseValue;
    contactTemplate.setDueDate.dayForInvoicePayment.value = contactDetail.invoiceIncomeValue;

    contactTemplate.setDueDate.dueToExpenses = { value: contactDetail.invoiceExpenseType };
    contactTemplate.setDueDate.dueToInvoicePayment = { value: contactDetail.invoiceIncomeType };

    contactTemplate.accountRecordSetting.selectReceivableRecorded = { id: contactDetail.accountsReceivableAccountId };
    contactTemplate.accountRecordSetting.selectPayableRecorded = { id: contactDetail.accountsPayableAccountId };
    contactTemplate.accountRecordSetting.selectInvoiceReceiptGoodsReceipt = {
      id: contactDetail.invoiceReceiptGoodsReceiptAccountId,
    };
  },
  DueDate(duedate) {
    return GetDueIn(duedate);
  },
  TableDueDate(duedate) {
    let textDueDate = "";
    let classDueDate = "";
    let dateDifference = GetDueIn(duedate);
    if (dateDifference > 7) {
      textDueDate = i18n.t("Text_ContactDetail_Remaining", { msg: dateDifference });
      classDueDate = "";
    } else if (dateDifference <= 7 && dateDifference >= !0) {
      textDueDate = i18n.t("Text_ContactDetail_Remaining", { msg: dateDifference });
      classDueDate = "textYellow";
    } else if (dateDifference == 0) {
      textDueDate = i18n.t("Today");
      classDueDate = "textRed";
    } else {
      textDueDate = i18n.t("Days_Passed", { msg: Math.abs(dateDifference) });
      classDueDate = "textRed";
    }
    return { textDueDate: textDueDate, classDueDate: classDueDate };
  },
  ConvertToContactForCreatePuunContact(_contact) {
    let contact = {
      name: _contact.merchantName,
      isVat: _contact.isVat,
      email: _contact.email,
      phone: _contact.phone,
      address: {
        homeNo: _contact.homeno,
        homeGroup: _contact.homeGroup,
        soi: _contact.soi,
        floorNo: _contact.floorNo,
        roomNo: _contact.roomNo,
        subDistrict: _contact.district1,
        district: _contact.district2,
        country: _contact.country,
        road: _contact.road,
        building: _contact.building,
        postCode: _contact.postCode,
      },
      merchantType: _contact.merchantType,
      contactName: _contact.merchantName,
      fax: _contact.fax,
      website: _contact.website,
      taxId: _contact.merchantTaxId,
      logoUrl: _contact.logoUrl,
      contactBranchModel: {
        id: _contact.contactBranchId,
        branchCode: _contact.merchantBranchCode,
      },
      contactCreditLimit: Enums.CreditLimitType.Default,
    };
    return contact;
  },
  ConvertToContactTemplateFromRd(_contactTemplateModelList) {
    const contactTemplateModelList = [];

    if (_contactTemplateModelList && _contactTemplateModelList.length > 0) {
      _contactTemplateModelList.forEach((item) => {
        const isThai = textHelper.IsHaveThaiText(item.province);
        const isBranchCodeCorrect = item.branchCode && item.branchCode.length === 5;
        const isTaxIdCorrect = item.taxId && item.taxId.length === 13;

        if (isThai) {
          if (isTaxIdCorrect && isBranchCodeCorrect) {
            if (item.name.includes("พี ยู ยู เอ็น อินเทลลิเจนท์")) {
              if (item.taxId === "0105557083391" && item.branchCode === "00000") {
                contactTemplateModelList.push(item);
              }
            } else {
              contactTemplateModelList.push(item);
            }
          }
        } else {
          contactTemplateModelList.push(item);
        }
      });
    }

    return contactTemplateModelList;
  },
  RedirectToPrintContactEnvelope(contactId) {
    let url = `${process.env.VUE_APP_PeakDocument}envelope?emi=${userInfo
      .MerchantId()
      .PeakEncryption()}&eti=${contactId.PeakEncryption()}&etti=${Enums.TransactionDocumentType.Envelope.PeakEncryption()}`;
    window.open(url);
  },
  CreateContactDefaultTemplate(financeType) {
    const companyName =
      financeType == Enums.FinanceType.InFlow ? i18n.t("Sample_Customer_Name") : i18n.t("Sample_Seller_Name");

    const setContactCreateTemplate = SetContactCreateTemplate();
    setContactCreateTemplate.modalCreateType = 2;

    setContactCreateTemplate.contactCode = {
      value: "C00000",
      validateError: false,
    };
    setContactCreateTemplate.taxId = {
      value: "0108012345678",
      validateError: false,
    };
    setContactCreateTemplate.typeCompany = {
      value: 7,
    };
    setContactCreateTemplate.companyName = {
      value: companyName,
      validateError: false,
    };
    setContactCreateTemplate.registeredAddress = {
      contactName: {
        value: "",
        validateError: false,
      },
      address: {
        value: i18n.locale == Enums.LanguageType.Thai ? "999 ถนนรัชดาภิเษก" : "999 Ratchadaphisek Rd",
        validateError: false,
      },
      road: {
        value: "",
        validateError: false,
      },
      building: {
        value: "",
        validateError: false,
      },
      city: {
        value: "",
        validateError: false,
      },
      state: {
        value: "",
        validateError: false,
      },
      district: {
        value: i18n.locale == Enums.LanguageType.Thai ? "ดินแดง" : "Din Daeng",
        validateError: false,
      },
      amphoe: {
        value: i18n.locale == Enums.LanguageType.Thai ? "ดินแดง" : "Din Daeng",
        validateError: false,
      },
      province: {
        value: i18n.locale == Enums.LanguageType.Thai ? "กรุงเทพมหานคร" : "Bangkok",
        validateError: false,
      },
      zipcode: {
        value: "10400",
        validateError: false,
      },
      country: {
        name: "Thailand",
        code: "TH",
      },
    };

    setContactCreateTemplate.email = {
      value: "demo@gmail.com",
      validateError: false,
    };

    setContactCreateTemplate.phoneNumber = {
      value: "0812345678",
      validateError: false,
    };

    setContactCreateTemplate.website = {
      value: "peakaccount.com",
      validateError: false,
    };

    setContactCreateTemplate.personToContact = [
      {
        id: 0,
        prefixName: {
          name: "ไม่มี",
          value: 0,
        },
        prefixOtherName: {
          value: "",
          validateError: false,
        },
        firstName: {
          value: i18n.locale == Enums.LanguageType.Thai ? "ทดสอบ" : "Test",
          validateError: false,
        },
        lastName: {
          value: i18n.locale == Enums.LanguageType.Thai ? "ปรีชาสามารถ" : "Contact",
          validateError: false,
        },
        nickName: {
          value: "",
          validateError: false,
        },
        department: {
          name: "ไม่มี",
          value: 0,
        },
        departmentOther: {
          value: "",
          validateError: false,
        },
        position: {
          value: "",
          validateError: false,
        },
        email: {
          value: "",
          validateError: false,
        },
        phoneNumber: {
          value: "",
          validateError: false,
        },
      },
    ];

    return setContactCreateTemplate;
  },
  CreateAddressDefault() {
    let addressList = {
      postalCode: "",
      province: "",
      district: "",
      subdistrict: "",
      addressPerson: "",
    };
    return addressList;
  },
  SplitAddress(address) {
    let splitaddresslist = [];
    if (address) {
      splitaddresslist = address
        .split(/\s|ต\.|อ\.|จ\.|ข\.|เขต|แขวง|ตำบล|อำเภอ|จังหวัด|ตำบล\.|อำเภอ\.|จังหวัด\./)
        .filter((item) => item !== "");
    }
    return splitaddresslist;
  },
  CheckPostalCodeInAddress(splitaddresslist) {
    return /\d/.test(splitaddresslist[splitaddresslist.length - 1]);
  },
  SetAddressNotPostalCode(address) {
    let setAddressNotPostalCode = this.CreateAddressDefault();
    if (address) {
      setAddressNotPostalCode.postalCode = "";
      setAddressNotPostalCode.province = address[address.length - 1];
      setAddressNotPostalCode.district = address[address.length - 2];
      setAddressNotPostalCode.subdistrict = address[address.length - 3];
      setAddressNotPostalCode.addressPerson = this.GetAddressPerson(
        address,
        setAddressNotPostalCode.subdistrict
      ).trim();
    }
    return setAddressNotPostalCode;
  },
  SetAddress(address) {
    let setAddress = this.CreateAddressDefault();
    if (address) {
      setAddress.postalCode = address[address.length - 1];
      setAddress.province = address[address.length - 2];
      setAddress.district = address[address.length - 3];
      setAddress.subdistrict = address[address.length - 4];
      setAddress.addressPerson = this.GetAddressPerson(address, setAddress.subdistrict).trim();
    }
    return setAddress;
  },
  GetAddressPerson(addressList, subdistrict) {
    let addressPerson = "";
    for (let x in addressList) {
      if (addressList[x] == subdistrict) {
        break;
      } else {
        addressPerson += addressList[x] + " ";
      }
    }
    return addressPerson;
  },
  GetContactModelByContactId(contactId) {
    return new Promise(async (resolve, reject) => {
      try {
        await store.dispatch("DoGetContactByContactIdListAsync", [contactId]);
        let contactList = store.getters.GetContactModelList;
        let contact = contactList.find((x) => x.id === contactId);
        if (contact) {
          resolve({ ...contact });
        }
        resolve(null);
      } catch (err) {
        console.error(err);
        reject(err);
      }
    });
  },
  ValidateContactRegisteredAddressForPackageError(contact) {
    if (
      !contact.registeredAddress.address.value ||
      !contact.registeredAddress.amphoe.value ||
      !contact.registeredAddress.district.value ||
      !contact.registeredAddress.province.value ||
      !contact.registeredAddress.zipcode.value
    ) {
      if (!contact.registeredAddress.address.value) {
        contact.registeredAddress.address.validateError = true;
      }
      if (!contact.registeredAddress.amphoe.value) {
        contact.registeredAddress.amphoe.validateError = true;
      }
      if (!contact.registeredAddress.district.value) {
        contact.registeredAddress.district.validateError = true;
      }
      if (!contact.registeredAddress.province.value) {
        contact.registeredAddress.province.validateError = true;
      }
      if (!contact.registeredAddress.zipcode.value) {
        contact.registeredAddress.zipcode.validateError = true;
      }
      return false;
    }
    return true;
  },
};

function SetContactCreateTemplate() {
  return {
    id: 0,
    contactBranchId: 0,
    modalCreateType: 1,
    logoUrl: "",
    contactFinanceType: {
      value: Enums.ContactFinanceType.All,
    },
    taxId: {
      value: "",
      validateError: false,
    },
    branchTypeId: 1,
    branchCode: {
      value: "00000",
      validateError: false,
    },
    contactContryId: 1,
    contactCode: {
      value: "",
      validateError: false,
    },
    typeOfPerson: { value: 2 },
    contactName: "",
    typeCompany: "",
    otherTypeCompany: "",
    verificationStatus: 0,
    companyName: {
      value: "",
      validateError: false,
    },
    prefixName: { value: Enums.PrefixNameType.Mr },
    prefixOtherName: {
      value: "",
      validateError: false,
    },
    firstname: {
      value: "",
      validateError: false,
    },
    lastname: {
      value: "",
      validateError: false,
    },
    registeredAddress: {
      contactName: {
        value: "",
        validateError: false,
      },
      address: {
        value: "",
        validateError: false,
      },
      road: {
        value: "",
        validateError: false,
      },
      building: {
        value: "",
        validateError: false,
      },
      city: {
        value: "",
        validateError: false,
      },
      state: {
        value: "",
        validateError: false,
      },
      district: {
        value: "",
        validateError: false,
      },
      amphoe: {
        value: "",
        validateError: false,
      },
      province: {
        value: "",
        validateError: false,
      },
      zipcode: {
        value: "",
        validateError: false,
      },
      country: { name: "Thailand", code: "TH" },
    },
    shippingAddress: {
      contactName: {
        value: "",
        validateError: false,
      },
      address: {
        value: "",
        validateError: false,
      },
      road: {
        value: "",
        validateError: false,
      },
      building: {
        value: "",
        validateError: false,
      },
      city: {
        value: "",
        validateError: false,
      },
      state: {
        value: "",
        validateError: false,
      },
      district: {
        value: "",
        validateError: false,
      },
      amphoe: {
        value: "",
        validateError: false,
      },
      province: {
        value: "",
        validateError: false,
      },
      zipcode: {
        value: "",
        validateError: false,
      },
      country: { name: "Thailand", code: "TH" },
    },
    email: {
      value: "",
      validateError: false,
    },
    phoneNumber: {
      value: "",
      validateError: false,
    },
    faxNumber: {
      value: "",
      validateError: false,
    },
    website: {
      value: "",
      validateError: false,
    },
    personToContact: [
      {
        id: 0,
        prefixName: { value: Enums.PrefixNameType.None },
        prefixOtherName: {
          value: "",
          validateError: false,
        },
        firstName: {
          value: "",
          validateError: false,
        },
        lastName: {
          value: "",
          validateError: false,
        },
        nickName: {
          value: "",
          validateError: false,
        },
        department: { value: Enums.DepartmentType.None },
        departmentOther: {
          value: "",
          validateError: false,
        },
        position: {
          value: "",
          validateError: false,
        },
        email: {
          value: "",
          validateError: false,
        },
        phoneNumber: {
          value: "",
          validateError: false,
        },
      },
    ],
    bankInformation: [
      {
        id: 0,
        bank: {
          name: "",
          bankReferenceBankId: Enums.BankReferenceType.NONE,
        },
        accountName: {
          value: "",
          validateError: false,
        },
        accountNumber: {
          value: "",
          validateError: false,
        },
        bankBranch: {
          value: "",
          validateError: false,
        },
      },
    ],
    setDueDate: {
      dayForExpenses: {
        value: "7",
        validateError: false,
      },
      dayForInvoicePayment: {
        value: "7",
        validateError: false,
      },
      dueToExpenses: { name: "", value: 0 },
      dueToInvoicePayment: { name: "", value: 0 },
    },
    accountRecordSetting: {
      selectReceivableRecorded: { id: 7 },
      selectPayableRecorded: { id: 58 },
      selectInvoiceReceiptGoodsReceipt: { id: 219 },
    },
    contactGroup: [],
    contactCreditLimit: {
      value: "0.00",
      validateError: false,
    },
    creditLimitSettingType: Enums.CreditLimitType.Default,
  };
}

function SetContactGroup(_contactGroup) {
  let contactGroupList = [];
  _contactGroup.forEach((contactGroup) => {
    contactGroupList.push({
      contactGroupId: contactGroup.id,
      bgLengthColor: contactGroup.color,
      description: contactGroup.description,
      name: contactGroup.name,
    });
  });
  return contactGroupList;
}

function SetBankInformation(_bankInformation) {
  let bankInformation = [];
  _bankInformation.forEach((bankInformationItem) => {
    bankInformation.push({
      id: bankInformationItem.id,
      bank: {
        name: "",
        bankReferenceBankId: bankInformationItem.bankReferenceBankId
          ? bankInformationItem.bankReferenceBankId
          : Enums.BankReferenceType.NONE,
      },
      accountName: {
        value: bankInformationItem.accountName,
        validateError: false,
      },
      accountNumber: {
        value: bankInformationItem.accountNumber,
        validateError: false,
      },
      bankBranch: {
        value: bankInformationItem.branch,
        validateError: false,
      },
    });
  });

  return bankInformation;
}

function SetPersonToContactDetail(_personToContactDetail) {
  let personToContact = [];

  _personToContactDetail.forEach((personToContactItem) => {
    personToContact.push({
      id: personToContactItem.id,
      firstName: {
        value: personToContactItem.firstName,
        validateError: false,
      },
      lastName: {
        value: personToContactItem.lastName,
        validateError: false,
      },
      nickName: {
        value: personToContactItem.nickName,
        validateError: false,
      },
      position: {
        value: personToContactItem.position,
        validateError: false,
      },
      email: {
        value: personToContactItem.personEmail,
        validateError: false,
      },
      phoneNumber: {
        value: personToContactItem.personPhone,
        validateError: false,
      },
      prefixName: { value: personToContactItem.personalNamePrefixTypeId },
      prefixOtherName: {
        value: personToContactItem.personalNamePrefixOther,
        validateError: false,
      },
      department: { value: personToContactItem.departmentTypeId },
      departmentOther: {
        value: personToContactItem.departmentOther,
        validateError: false,
      },
    });
  });

  return personToContact;
}
export const ValidateContactBusinessNameInformationError = (contact) => {
  if (
    !contact.prefixOtherName.validateError &&
    !(contact.companyName.validateError || contact.firstname.validateError) &&
    !contact.lastname.validateError
  ) {
    return true;
  }
  return false;
};

export const ValidateContactRegisteredAddressError = (contact) => {
  if (
    !contact.registeredAddress.contactName.validateError &&
    !contact.registeredAddress.address.validateError &&
    !contact.registeredAddress.road.validateError &&
    !contact.registeredAddress.building.validateError &&
    !contact.registeredAddress.city.validateError &&
    !contact.registeredAddress.state.validateError &&
    !contact.registeredAddress.district.validateError &&
    !contact.registeredAddress.amphoe.validateError &&
    !contact.registeredAddress.province.validateError &&
    !contact.registeredAddress.zipcode.validateError
  ) {
    return true;
  }
  return false;
};

export const ValidateContactShippingAddressError = (contact) => {
  if (
    !contact.shippingAddress.contactName.validateError &&
    !contact.shippingAddress.address.validateError &&
    !contact.shippingAddress.road.validateError &&
    !contact.shippingAddress.building.validateError &&
    !contact.shippingAddress.city.validateError &&
    !contact.shippingAddress.state.validateError &&
    !contact.shippingAddress.district.validateError &&
    !contact.shippingAddress.amphoe.validateError &&
    !contact.shippingAddress.province.validateError &&
    !contact.shippingAddress.zipcode.validateError
  ) {
    return true;
  }
  return false;
};

export const ValidateContactInfoError = (contact) => {
  if (
    !contact.email.validateError &&
    !contact.phoneNumber.validateError &&
    !contact.faxNumber.validateError &&
    !contact.website.validateError
  ) {
    return true;
  }
  return false;
};

export const ValidateContactPersonError = (contact) => {
  let isCheckValidateContact = false;
  if (contact.personToContact && contact.personToContact.length > 0) {
    for (let count = 0; count < contact.personToContact.length; count++) {
      if (
        !contact.personToContact[count].firstName.validateError &&
        !contact.personToContact[count].lastName.validateError &&
        !contact.personToContact[count].nickName.validateError &&
        !contact.personToContact[count].position.validateError &&
        !contact.personToContact[count].email.validateError &&
        !contact.personToContact[count].phoneNumber.validateError
      ) {
        isCheckValidateContact = true;
      }
    }
  }
  return isCheckValidateContact;
};

export const ValidateContactBankAccountError = (contact) => {
  let isCheckValidateContact = false;
  if (contact.bankInformation !== null) {
    for (let count = 0; count < contact.bankInformation.length; count++) {
      if (
        !contact.bankInformation[count].accountName.validateError &&
        !contact.bankInformation[count].accountNumber.validateError &&
        !contact.bankInformation[count].bankBranch.validateError
      ) {
        isCheckValidateContact = true;
      }
    }
  }
  return isCheckValidateContact;
};

export const ValidateContactSetDueDateError = (contact) => {
  if (!contact.setDueDate.dayForExpenses.validateError && !contact.setDueDate.dayForInvoicePayment.validateError) {
    return true;
  }
  return false;
};

export const ValidateContactCreditLimitError = (contact) => {
  if (!contact.contactCreditLimit.validateError) {
    return true;
  }
  return false;
};

export const ValidateContactCodeError = (contact) => {
  if (!contact.contactCode.validateError) {
    return true;
  }
  return false;
};
export const ConvertedTransactionTypeForDashboardContact = (transactionTypeForDashboardContact) => {
  switch (transactionTypeForDashboardContact) {
    case Enums.TransactionTypeForDashboardContact.Quotation:
      return Enums.TransactionType.Quotation;
    case Enums.TransactionTypeForDashboardContact.Deposit:
      return Enums.TransactionType.Deposit;
    case Enums.TransactionTypeForDashboardContact.Invoice:
      return Enums.TransactionType.Invoice;
    case Enums.TransactionTypeForDashboardContact.Receipt:
      return Enums.TransactionType.Receipt;
    case Enums.TransactionTypeForDashboardContact.TaxInvoice:
      return Enums.TransactionType.TaxInvoice;
    case Enums.TransactionTypeForDashboardContact.CreditNote:
      return Enums.TransactionType.CreditNote;
    case Enums.TransactionTypeForDashboardContact.DebitNote:
      return Enums.TransactionType.DebitNote;
    case Enums.TransactionTypeForDashboardContact.BillingNote:
      return Enums.TransactionType.BillingNote;
    case Enums.TransactionTypeForDashboardContact.PurchaseOrder:
      return Enums.TransactionType.Quotation;
    case Enums.TransactionTypeForDashboardContact.ReceiveDeposit:
      return Enums.TransactionType.Deposit;
    case Enums.TransactionTypeForDashboardContact.PurchaseInventoryRecord:
      return Enums.TransactionType.Invoice;
    case Enums.TransactionTypeForDashboardContact.ExpenseRecord:
      return Enums.TransactionType.Invoice;
    case Enums.TransactionTypeForDashboardContact.PurchaseAsset:
      return Enums.TransactionType.Invoice;
    case Enums.TransactionTypeForDashboardContact.CombinedPaymentNote:
      return Enums.TransactionType.BillingNote;
  }
};
function BankInformation(_bankInfoList) {
  let bankInfoTemplate = [];
  if (_bankInfoList !== null) {
    for (let count = 0; count < _bankInfoList.length; count++) {
      let bankInfo = _bankInfoList[count];
      let bankInfoItem = {
        id: bankInfo.id,
        bankName: bankInfo.bank.name,
        accountNumber: bankInfo.accountNumber.value,
        accountName: bankInfo.accountName.value,
        branch: bankInfo.bankBranch.value,
        bankReferenceBankId: bankInfo.bank.bankReferenceBankId >= 0 ? bankInfo.bank.bankReferenceBankId : null,
      };
      bankInfoTemplate.push(bankInfoItem);
    }
  }
  return bankInfoTemplate;
}
function ToContactGroupIdList(_contactGroupList) {
  let contactGroupIdList = [];
  if (_contactGroupList !== null) {
    for (let count = 0; count < _contactGroupList.length; count++) {
      contactGroupIdList.push(_contactGroupList[count].contactGroupId);
    }
  }
  return contactGroupIdList;
}
function PersonToContact(_personToContactList) {
  let personToContactTemplate = [];
  if (_personToContactList !== null) {
    for (let count = 0; count < _personToContactList.length; count++) {
      let personContact = _personToContactList[count];
      let personContactItem = {
        id: personContact.id,
        firstname: personContact.firstName.value,
        lastname: personContact.lastName.value,
        nickname: personContact.nickName.value,
        position: personContact.position.value,
        personPhone: personContact.phoneNumber.value,
        personEmail: personContact.email.value,
        isMainPerson: 1,
        isSendEmail: 1,
        personalNamePrefixTypeId: personContact.prefixName.value,
        personalNamePrefixOther: personContact.prefixOtherName.value,
        departmentTypeId: personContact.department.value,
        departmentOther: personContact.departmentOther.value,
      };
      personToContactTemplate.push(personContactItem);
    }
  }
  return personToContactTemplate;
}
function GetDueIn(duedate) {
  let toDay = new Date();
  let dueDate = new Date(duedate);
  let dayDifference = dueDate.getTime() - toDay.getTime();
  let DueIn = Math.ceil(dayDifference / (1000 * 3600 * 24));
  return DueIn;
}

export function ValidateImportContactList(importContactList, actionType, isAllowCreateContactDuplicate) {
  let isAnyValidateError = false;
  let existedContactCodeSet = new Set();
  let existedContactBranchCodeTaxIdMapper = {}; // { ["Contact_Branch_Code"]: "Contact_TaxId" }
  let existedContactBranchCodeFirstNameLastNameMapper = {}; // { ["Contact_Branch_Code"]: { ["Contact_First_Name"]: "Contact_Last_Name" } }

  for (const importContact of importContactList) {
    const isValidateError = ValidateImportContact(
      importContact,
      existedContactCodeSet,
      existedContactBranchCodeTaxIdMapper,
      existedContactBranchCodeFirstNameLastNameMapper,
      actionType,
      isAllowCreateContactDuplicate
    );

    if (importContact.isPrimary) {
      if (importContact.general.code.value) {
        existedContactCodeSet.add(importContact.general.code.value);
      }

      if (importContact.general.taxId.value) {
        existedContactBranchCodeTaxIdMapper[importContact.general.branchCode.value] = importContact.general.taxId.value;
      }

      if (importContact.general.firstName.value) {
        existedContactBranchCodeFirstNameLastNameMapper[importContact.general.branchCode.value] = {
          [importContact.general.firstName.value]: importContact.general.lastName.value,
        };
      }
    }

    isAnyValidateError = isValidateError || isAnyValidateError;
  }

  return isAnyValidateError;
}

export function ValidateImportContact(
  importContact,
  existedContactCodeSet,
  existedContactBranchCodeTaxIdMapper,
  existedContactBranchCodeFirstNameLastNameMapper,
  actionType,
  isAllowCreateContactDuplicate
) {
  let isValidateError = false;
  importContact.isValidateError = false;

  if (importContact.isPrimary) {
    isValidateError = ValidateImportContactCode(importContact.general.code, existedContactCodeSet) || isValidateError;

    isValidateError =
      ValidateImportContactTaxId(
        importContact.general.taxId,
        importContact.general.branchCode,
        importContact.general.nationalityType.value.code === "TH",
        existedContactBranchCodeTaxIdMapper,
        actionType,
        isAllowCreateContactDuplicate
      ) || isValidateError;
    isValidateError =
      ValidateImportContactBranchCode(importContact.general.branchCode, importContact.general.branchType.value.value) ||
      isValidateError;

    isValidateError =
      ValidateImportContactFirstName(
        importContact.general.firstName,
        importContact.general.lastName,
        importContact.general.branchCode,
        existedContactBranchCodeFirstNameLastNameMapper,
        actionType,
        isAllowCreateContactDuplicate
      ) || isValidateError;
    isValidateError =
      ValidateImportContactLastName(
        importContact.general.firstName,
        importContact.general.lastName,
        importContact.general.branchCode,
        existedContactBranchCodeFirstNameLastNameMapper,
        actionType,
        isAllowCreateContactDuplicate
      ) || isValidateError;

    isValidateError =
      ValidateImportContactFieldMaxLength(importContact.registeredAddress.contactName) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.registeredAddress.address) || isValidateError;
    isValidateError =
      ValidateImportContactFieldMaxLength(importContact.registeredAddress.subDistrict) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.registeredAddress.district) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.registeredAddress.province) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.registeredAddress.postcode) || isValidateError;

    isValidateError = ValidateImportContactFieldMaxLength(importContact.officeAddress.contactName) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.officeAddress.address) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.officeAddress.subDistrict) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.officeAddress.district) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.officeAddress.province) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.officeAddress.postcode) || isValidateError;

    isValidateError = ValidateImportContactFieldMaxLength(importContact.contactChannel.email) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.contactChannel.phone) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.contactChannel.website) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.contactChannel.fax) || isValidateError;

    isValidateError = ValidateImportContactFieldMaxLength(importContact.bank.accountName) || isValidateError;
    isValidateError = ValidateImportContactBankNumber(importContact.bank.accountNumber) || isValidateError;
    isValidateError = ValidateImportContactBankNumber(importContact.bank.accountBranchNumber) || isValidateError;
    isValidateError =
      ValidateImportContactInvoiceDueDate(
        importContact.dueDateSetting.invoiceDueDate,
        importContact.dueDateSetting.invoiceDueDateType.value.value
      ) || isValidateError;
    isValidateError =
      ValidateImportContactInvoiceDueDate(
        importContact.dueDateSetting.expenseDueDate,
        importContact.dueDateSetting.expenseDueDateType.value.value
      ) || isValidateError;

    isValidateError =
      ValidateImportContactCreditLimitAmount(
        importContact.creditLimit.amount,
        importContact.creditLimit.creditLimitType.value.value
      ) || isValidateError;
  }

  if (importContact.isHaveContactPerson) {
    isValidateError = ValidateImportContactFieldMaxLength(importContact.contactPerson.firstName) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.contactPerson.lastName) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.contactPerson.nickName) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.contactPerson.email) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.contactPerson.phone) || isValidateError;
    isValidateError = ValidateImportContactFieldMaxLength(importContact.contactPerson.position) || isValidateError;
  }

  if (importContact.isHaveGroup) {
    isValidateError = ValidateImportContactGroup(importContact.group) || isValidateError;
  }

  importContact.isValidateError = isValidateError;

  return isValidateError;
}

export function ValidateImportContactCode(code, existedContactCodeSet) {
  code.isValidateError = false;
  if (existedContactCodeSet.has(code.value)) {
    code.isValidateError = true;
    code.alertMessage = i18n.t("Contact_Code_Duplicated_Same_File");
  } else if (code.value.length > code.maxLength) {
    code.isValidateError = true;
    code.alertMessage = i18n.t("Input_Over_Limit");
  }
  return code.isValidateError;
}

export function ValidateImportContactTaxId(
  taxId,
  branchCode,
  isThaiFormat,
  existedContactBranchCodeTaxIdMapper,
  actionType,
  isAllowCreateContactDuplicate
) {
  taxId.isValidateError = false;
  if (
    taxId.value &&
    actionType === Enums.ImportContactActionType.Create &&
    !isAllowCreateContactDuplicate &&
    existedContactBranchCodeTaxIdMapper[branchCode.value] !== undefined &&
    existedContactBranchCodeTaxIdMapper[branchCode.value] === taxId.value
  ) {
    taxId.isValidateError = true;
    taxId.alertMessage = i18n.t("Contact_TaxId_Duplicated_Same_File");
  } else if (taxId.value && isThaiFormat && !/^\d+$/.test(taxId.value)) {
    taxId.isValidateError = true;
    taxId.alertMessage = i18n.t("Input_Only_Number");
  } else if (taxId.value && isThaiFormat && taxId.value.length !== 13) {
    taxId.isValidateError = true;
    taxId.alertMessage = i18n.t("Invalid_Tax_ID_Format");
  } else if (taxId.value && taxId.value.length > taxId.maxLength) {
    taxId.isValidateError = true;
    taxId.alertMessage = i18n.t("Input_Over_Limit");
  }
  return taxId.isValidateError;
}

export function ValidateImportContactBranchCode(branchCode, branchType) {
  branchCode.isValidateError = false;
  if (branchCode.value && !/^\d{5}$/.test(branchCode.value)) {
    branchCode.isValidateError = true;
    branchCode.alertMessage = i18n.t("Incorrect_Data_Format_Please_Check_Description_Again");
  } else if (branchType === Enums.BranchCompanyType.Branch && branchCode.value === "") {
    branchCode.isValidateError = true;
    branchCode.alertMessage = i18n.t("Please_Fill_In_X", { msg: i18n.t("Branch_Number") });
  }
  return branchCode.isValidateError;
}

export function ValidateImportContactFirstName(
  firstName,
  lastName,
  branchCode,
  existedContactBranchCodeFirstNameLastNameMapper,
  actionType,
  isAllowCreateContactDuplicate
) {
  firstName.isValidateError = false;
  if (firstName.value === "") {
    firstName.isValidateError = true;
    firstName.alertMessage = i18n.t("Please_Fill_In_X", { msg: i18n.t("Merchant_Name") });
  } else if (
    !isAllowCreateContactDuplicate &&
    actionType === Enums.ImportContactActionType.Create &&
    existedContactBranchCodeFirstNameLastNameMapper[branchCode.value] !== undefined &&
    existedContactBranchCodeFirstNameLastNameMapper[branchCode.value][firstName.value] !== undefined &&
    existedContactBranchCodeFirstNameLastNameMapper[branchCode.value][firstName.value] === lastName.value
  ) {
    firstName.isValidateError = true;
    firstName.alertMessage = i18n.t("Contact_Name_Duplicated_Same_File");
  } else if (firstName.value.length > firstName.maxLength) {
    firstName.isValidateError = true;
    firstName.alertMessage = i18n.t("Input_Over_Limit");
  }
  return firstName.isValidateError;
}

export function ValidateImportContactLastName(
  firstName,
  lastName,
  branchCode,
  existedContactBranchCodeFirstNameLastNameMapper,
  actionType,
  isAllowCreateContactDuplicate
) {
  lastName.isValidateError = false;
  if (
    !isAllowCreateContactDuplicate &&
    actionType === Enums.ImportContactActionType.Create &&
    existedContactBranchCodeFirstNameLastNameMapper[branchCode.value] !== undefined &&
    existedContactBranchCodeFirstNameLastNameMapper[branchCode.value][firstName.value] !== undefined &&
    existedContactBranchCodeFirstNameLastNameMapper[branchCode.value][firstName.value] === lastName.value
  ) {
    lastName.isValidateError = true;
    lastName.alertMessage = i18n.t("Contact_Last_Name_Duplicated_Same_File");
  } else if (lastName.value.length > lastName.maxLength) {
    lastName.isValidateError = true;
    lastName.alertMessage = i18n.t("Input_Over_Limit");
  }
  return lastName.isValidateError;
}

export function ValidateImportContactFieldMaxLength(importContactField) {
  importContactField.isValidateError = false;
  if (importContactField.value.length > importContactField.maxLength) {
    importContactField.isValidateError = true;
    importContactField.alertMessage = i18n.t("Input_Over_Limit");
  }
  return importContactField.isValidateError;
}

export function ValidateImportContactBankNumber(number) {
  number.isValidateError = false;
  if (number.value && !/^\d+$/.test(number.value)) {
    number.isValidateError = true;
    number.alertMessage = i18n.t("Input_Only_Number");
  } else {
    number.value = number.value.slice(0, number.maxLength);
  }
  return number.isValidateError;
}

export function ValidateImportContactInvoiceDueDate(invoiceDueDate, invoiceDueDateType) {
  invoiceDueDate.isValidateError = false;
  switch (invoiceDueDateType) {
    case Enums.ContactInvoiceDueDateType.DayAfterIssueDate:
      if (invoiceDueDate.value === "") {
        invoiceDueDate.isValidateError = true;
        invoiceDueDate.alertMessage = i18n.t("Please_Fill_In_X", { msg: i18n.t("X_Variable") });
      } else if (!/^(0|[1-9][0-9]*)$/.test(invoiceDueDate.value)) {
        invoiceDueDate.isValidateError = true;
        invoiceDueDate.alertMessage = i18n.t("Input_Only_Number");
      } else if (parseInt(invoiceDueDate.value) > 366) {
        invoiceDueDate.isValidateError = true;
        invoiceDueDate.alertMessage = i18n.t("Input_Over_Limit");
      }
      break;
    case Enums.ContactInvoiceDueDateType.DateOfFollowingMonth:
      if (invoiceDueDate.value === "") {
        invoiceDueDate.isValidateError = true;
        invoiceDueDate.alertMessage = i18n.t("Please_Fill_In_X", { msg: i18n.t("X_Variable") });
      } else if (!/^[1-9]\d*$/.test(invoiceDueDate.value)) {
        invoiceDueDate.isValidateError = true;
        invoiceDueDate.alertMessage = i18n.t("Input_Only_Number");
      } else if (parseInt(invoiceDueDate.value) > 28) {
        invoiceDueDate.isValidateError = true;
        invoiceDueDate.alertMessage = i18n.t("Input_Over_Limit");
      }
      break;
    case Enums.ContactInvoiceDueDateType.MerchantDefault:
    case Enums.ContactInvoiceDueDateType.EndOfIssuedMonth:
    case Enums.ContactInvoiceDueDateType.EndOfFollowingMonth:
      break;
  }
  return invoiceDueDate.isValidateError;
}

export function ValidateImportContactCreditLimitAmount(amount, creditLimitType) {
  amount.isValidateError = false;
  switch (creditLimitType) {
    case Enums.CreditLimitType.Custom:
      if (!/^-?\d{1,3}(,\d{3})*(\.\d+)?$/.test(amount.value)) {
        amount.isValidateError = true;
        amount.alertMessage = i18n.t("Input_Only_Number");
      } else if (amount.value.ToNumber() > 999999999.9999) {
        amount.isValidateError = true;
        amount.alertMessage = i18n.t("Price_Q_validate");
      }
      break;
    case Enums.CreditLimitType.Default:
    case Enums.CreditLimitType.Unlimit:
      break;
  }
  return amount.isValidateError;
}

export function ValidateImportContactGroup(group) {
  group.isValidateError = false;
  if (group.value.name && group.value.id === 0) {
    group.isValidateError = true;
    group.alertMessage = i18n.t("Incorrect_Data_Format_Please_Check_Description_Again");
  }
  return group.isValidateError;
}
